'use client';

import { createContext, useContext } from 'react';

interface AutomaticWithdrawalsContextValue {
  isEnabled: boolean;
  setIsEnabled: (value: boolean) => void;
}

export const AutomaticWithdrawalsContext =
  createContext<AutomaticWithdrawalsContextValue | null>(null);

export const useAutomaticWithdrawals = () => {
  const context = useContext(AutomaticWithdrawalsContext);

  if (!context) {
    throw new Error(
      'useAutomaticWithdrawals must be used within AutomaticWithdrawalsContext.Provider',
    );
  }

  return context;
};
